// extracted by mini-css-extract-plugin
module.exports = {"wrap":"te","heading":"ue","items":"ve","featureCss":"we","disabled":"xe","imgCss":"ye"};